import { useEffect, useRef } from "react";
import React from "react";
import {Html5QrcodeScanner} from "html5-qrcode";
import {Html5QrcodeScannerConfig} from "html5-qrcode/html5-qrcode-scanner";

type Props = {
    onScanSuccess: (decodedText: string) => void;
    onScanFailure?: (errorMessage: string) => void;
    fps?: number;
    qrbox?: number;
};

export function QrCodeScanner({
    onScanSuccess,
    onScanFailure,
    fps = 100,
    qrbox = 1000,
}: Props) {
    const readerRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (readerRef.current) {
            const config : Html5QrcodeScannerConfig = {
                fps: fps,
                qrbox: qrbox,
                showZoomSliderIfSupported: true,
                supportedScanTypes: [0]
            }
            const html5QrcodeScanner = new Html5QrcodeScanner("qr-reader", config, false);
            html5QrcodeScanner.render(onScanSuccess, onScanFailure);
            return () => {
                html5QrcodeScanner.clear().catch((error) => {
                    console.error("Failed to clear QR Code Scanner", error);
                });
            };
        }
    }, [fps, qrbox, onScanSuccess, onScanFailure]);

    return <div id="qr-reader" ref={readerRef}></div>;
}